// Vídeo, guia e cards que o servidor anexa à resposta; a mensagem salva volta do servidor e é conferida de novo.

export const ID_VIDEO = /^[A-Za-z0-9_-]{11}$/;

/** Guia válido para desenhar. */
export const guiaValido = (g) =>
  !!g &&
  typeof g === "object" &&
  typeof g.artigo === "string" &&
  typeof g.titulo === "string" &&
  Array.isArray(g.passos) &&
  g.passos.length > 0 &&
  g.passos.every((p) => !!p && typeof p.texto === "string" && (p.alvo === undefined || typeof p.alvo === "string"));

/** Mídia válida para desenhar. */
export const midiaValida = (m) => !!m && typeof m === "object" && m.tipo === "video" && typeof m.id === "string" && ID_VIDEO.test(m.id);

export const urlDoVideo = (id, inicio) => `https://www.youtube-nocookie.com/embed/${id}${inicio ? `?start=${inicio}` : ""}`;

/** Passo a passo válido: lista de cards com título; guia e vídeo só se válidos. */
export function passosValidos(p) {
  if (!p || typeof p !== "object" || !Array.isArray(p.cards) || !p.cards.length) return null;
  const cards = p.cards.filter((c) => !!c && typeof c.titulo === "string" && c.titulo);
  if (!cards.length) return null;
  return {
    artigo: { id: "passos", titulo: typeof p.artigo?.titulo === "string" ? p.artigo.titulo : "Passo a passo" },
    cards: cards.map((c) => ({
      titulo: c.titulo,
      ...(typeof c.sub === "string" && c.sub && { sub: c.sub }),
    })),
    ...(guiaValido(p.guia) && { guia: p.guia }),
    ...(midiaValida({ tipo: "video", ...p.video }) && { video: { id: p.video.id, titulo: String(p.video.titulo ?? "") } }),
  };
}

